import { render, staticRenderFns } from "./StaffPost.vue?vue&type=template&id=21bec761&scoped=true"
import script from "./StaffPost.vue?vue&type=script&lang=js"
export * from "./StaffPost.vue?vue&type=script&lang=js"
import style0 from "./StaffPost.vue?vue&type=style&index=0&id=21bec761&prod&scoped=true&lang=css"
import style1 from "./StaffPost.vue?vue&type=style&index=1&id=21bec761&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bec761",
  null
  
)

export default component.exports